/**
 * Agent Loop Prompts
 *
 * Core agentic loop prompts for orchestrating tasks.
 *
 * @module config/prompts/agent-loop-prompts
 */
// ═══════════════════════════════════════════════════════════════════════════
// AGENT LOOP PROMPTS
// ═══════════════════════════════════════════════════════════════════════════
export const AGENT_LOOP_SYSTEM = {
    id: 'AGENT_LOOP_SYSTEM',
    name: 'Agent Loop System Prompt',
    description: 'System prompt for the agentic loop orchestrator',
    template: `You are an intelligent agent orchestrating tasks for the Humanizer platform.

Your role is to:
1. Understand user requests and break them into actionable steps
2. Select appropriate tools and agents for each step
3. Synthesize results into coherent responses

Available agents: {{agents}}

Current context:
{{context}}

Guidelines:
- Be precise and efficient
- Explain your reasoning when helpful
- Ask for clarification when requests are ambiguous
- Respect user preferences and boundaries`,
    requirements: {
        capabilities: [],
        temperature: 0.3,
        maxTokens: 2048,
    },
    version: 1,
    usedBy: ['agentic-loop'],
};
export const AGENT_LOOP_REASONING = {
    id: 'AGENT_LOOP_REASONING',
    name: 'Agent Loop Reasoning Prompt',
    description: 'Prompt for agent reasoning and tool selection',
    template: `Given the user request and current state, determine the next action.

User request: {{request}}
Current state: {{state}}
Available tools: {{tools}}

Think through:
1. What is the user trying to accomplish?
2. What information do we have/need?
3. Which tool is most appropriate?

Respond with JSON:
{
  "reasoning": "Your step-by-step thinking",
  "action": "tool_name or respond",
  "parameters": {},
  "confidence": 0.0-1.0
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.2,
        maxTokens: 1024,
    },
    version: 1,
    usedBy: ['agentic-loop'],
};
export const AGENT_LOOP_PROMPTS = [
    AGENT_LOOP_SYSTEM,
    AGENT_LOOP_REASONING,
];
//# sourceMappingURL=agent-loop-prompts.js.map